import React from "react";
import PhotoGallery from './PhotoGallery';
class Gallery extends React.Component {
  render() {
    const { message } = this.props
    return (
      <>
        <div className="gallery-wrapper">
          <PhotoGallery
              images={message.list}
              showFullscreenButton={false}
              showPlayButton={false}
              autoPlay={false}
              slideInterval={6000}
            />
        </div>
      </>
    );
  }
}

export default Gallery;
